module.exports = __webpack_public_path__ + "img/BankID_logo_black.f5b79819.svg";